"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEN = void 0;
exports.LEN = {
    alias: 'NUM_CARACT',
    description: 'Retorna o número de caracteres de um texto',
    arg_names: ['string_to_num_caract'],
    args_description: ['texto para extrair o número de caracteres'],
};
